// Feature layer json definitions
const customFeatureLayersJson = [
  {
    type: 'geonode',
    url: 'https://geoserver.dainst.org/',
    id: 6006,
    name: 'Daard Database',
    visible: true
  }
];

export {customFeatureLayersJson};